import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';

import './ParkingDetail.scss';

import commonConstant from '../../common/_commonConstant';
import { randomNumber } from '../../common/_commonFunction';
import { VehicleOut, Loading, ModalReceipts, Problem, ParkingGate } from '../../components';
import { fetchGetBuildingByBuildingID } from '../../actions';
import {
  buildingName,
  buildingRefNumber,
  carImage,
  vehicleLicensePlate,
  createBy,
  dateDDMMYYFormat,
  dateDDMMYYYYFormat,
  findHaveOvernight,
  getTimeHHMM,
  isAlreadyExist,
  isMember,
  isOverdue,
  labelVehicleType,
  minToHM,
  minToHr,
  minutesToHours,
  msToHM,
  overnightAmount,
  overnightTime,
  parkingID,
  parkingOverTime,
  parkingTimeIn,
  parkingTimeOut,
  parkingTimeTotal,
  parkingUntil,
  paymentTotalFeeAmount,
  paymentTotalAmount,
  paymentType,
  problemColor,
  problemName,
  summaryDiscount,
  timeFormatHHMM,
  timestampToHr,
  totalParkingTimeMinutes,
  validateMoney,
  validateToShowDash,
  vehicleBrand,
  vehicleColor,
  vehicleModel,
  vehicleProvince,
  vehicleType,
  vehicleYear, parkingDayConfig,
} from '../../helpers';

class ParkingDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalVehicleOut': false,
      'modalProblem': false,
      'updateProblem': null,
      'type': null,
      'loading': false,
      'modalReceipts': false,
      'activeIndexReceipts': null,
      'modalParkingGate': false,
    };
    if (!props.getBuildingByRefNo) {
      props.dispatch(fetchGetBuildingByBuildingID(props.match.params.buildingRefNo));
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { carExit, deleteProblem } = this.props;

    if (nextProps.carExit && nextProps.carExit.status === 200 && nextProps.carExit !== carExit) {
      return this.handleModal('modalVehicleOut');
    } else if (nextProps.deleteProblem && nextProps.deleteProblem && nextProps.deleteProblem !== deleteProblem) {
      return this.setState({ 'loading': false });
    }
  }

  handleLogProblem = () => {
    const { getParkingStatusById } = this.props;

    if (!getParkingStatusById.parkingProblem || getParkingStatusById.parkingProblem.length === 0) {
      return null;
    }
    return getParkingStatusById.parkingProblem.map((element, index) => (
      <div className="problem bg-white" key={randomNumber()}>
        <div className="title">
          <div>
            <span className={`dot${problemColor(element) ? ` ${problemColor(element)}` : ''}`} />
            <span className={`problem-name-${index}`}>{problemName(element.problem)}</span>
          </div>
          {
            !isAlreadyExist(getParkingStatusById) && !element.deletedAt ?
              <span
                id={`problem-delete-${index}`}
                className="icon exit fas fa-times"
                onClick={() => this.handleShowModalProblem(commonConstant.deleteProblem, element)}
              />
              : null
          }
        </div>
        <div className="detail-text">
          <div className="problem-detail">
            <div id={`problem-detail-${index}`}>- {element.problemDetail}</div>
            {
              !isAlreadyExist(getParkingStatusById) && !element.deletedAt ?
                <span
                  id={`problem-update-${index}`}
                  className="icon fas fa-edit"
                  onClick={() => this.handleShowModalProblem(commonConstant.updateProblem, element)}
                />
                : null
            }
          </div>
        </div>
      </div>
    ));
  }

  handleDetailParkingStatus = () => {
    const { getParkingStatusById, getParkingStatus, match, getBuildingByRefNo } = this.props;

    if (getParkingStatusById.parking.customerParkingInType === 'MEMBER' && paymentTotalAmount(getParkingStatus) === 0 && (parkingDayConfig(getBuildingByRefNo, getParkingStatus.parking.parkingGateIn).chargeCustomer === commonConstant.chargeTypeNoCharge || parkingDayConfig(getBuildingByRefNo, getParkingStatus.parking.parkingGateIn).chargeCustomer === commonConstant.chargeTypeVisitor)) {
      return (
        <div className={`detail-status member ${isAlreadyExist(getParkingStatusById) ? 'gray' : 'green'} mb`}>
          {
            !isAlreadyExist(getParkingStatusById) ?
              <div className="fee"><span className="icon icon-car-money" />ค่าบริการ</div>
              : null
          }
          <div className="box-detail">
            <span className="icon icon-crown" />
            <span className="detail">
              <div className="member" id="parking-customer-type-member">
                คุณเป็นสมาชิก
              </div>
              {
                !isAlreadyExist(getParkingStatusById) ?
                  <div className="description">ไม่มีค่าบริการเพิ่มเติม</div>
                  : null
              }
            </span>
          </div>
        </div>
      );
    } else if (isAlreadyExist(getParkingStatusById)) {
      return null;
    }
    return (
      <>
        <div className={`detail-status ${isOverdue(getParkingStatus) ? 'red' : 'green'} mb`}>
          <div className="title-unit">
            <span>
              <span className="icon icon-car-money" />
              ค่าบริการ
            </span>
            <span>
              จากเวลาที่จอดได้ถึงล่าสุด
              <span className={`icon center far fa-clock ${isOverdue(getParkingStatus) ? 'text-red' : 'text-green'}`} />
              <span
                id="parking-until-time"
                className={`${isOverdue(getParkingStatus) ? 'text-red' : 'text-green'}`}
              >
                {validateToShowDash(timeFormatHHMM(parkingUntil(getParkingStatus)))}
              </span>
            </span>
          </div>
          <div className="box-flex">
            <div className="bg-white w-40 box-center">
              <div className="title text-center">เวลาที่จอดเกิน</div>
              <div
                id="parking-over-time"
                className={`${isOverdue(getParkingStatus) ? 'text-red' : 'text-green'} text-large`}
              >
                {
                  isOverdue(getParkingStatus) ?
                    validateToShowDash(msToHM(parkingOverTime(getParkingStatus)))
                    : msToHM(0)
                }
              </div>
            </div>
            <div className="bg-white w-60 box-center">
              <div className="title text-center">ค่าบริการ</div>
              <div className={`${isOverdue(getParkingStatus) ? 'text-red' : 'text-green'} text-large`}>
                <span className="bold mr" id="parking-fee-amount">
                  {
                    isOverdue(getParkingStatus) ?
                      validateMoney(paymentTotalAmount(getParkingStatus) ? paymentTotalAmount(getParkingStatus).toLocaleString() : null)
                      : 0
                  }
                </span> บาท
              </div>
            </div>
          </div>
        </div>
        <div className="bg-gray mb">
          <div className="title-unit">
            <span>
              <span className="icon far fa-clock" />
              รายละเอียดค่าบริการ
            </span>
          </div>
          <div className="box-flex">
            <div className="bg-white w-33 box-center stretch">
              <div className="title text-center no-border mt-5">สิทธิจอดรถฟรี</div>
              <div className="detail-text mb-15">
                <span className="mr min-48" id="vehicle-free-parking-minutes">
                  {(minToHM(summaryDiscount(getParkingStatus)))}
                </span>
              </div>
            </div>
            <div className="bg-white w-33 box-center stretch">
              <div className="title text-center no-border mt-5">ค่าบริการจอดรถ</div>
              <div className="detail-text mb-15">
                <div className="mr min-48" id="vehicle-fee-parking">
                  {validateMoney(paymentTotalFeeAmount(getParkingStatus), true)}
                </div> บาท
              </div>
            </div>
            <div className="bg-white w-33 box-center stretch">
              <div className="title text-center no-border no-flex mt-5">
                <div>ค่าปรับจอดรถค้างคืน</div>
                <div className="description">
                  {
                    getBuildingByRefNo.buildingConfig.buildingConfig.config.car.parking.overnight.overnightChargeType === commonConstant.twentyFourHours ?
                      '*ค่าปรับจะถูกเก็บหลังการจอดต่อเนื่อง 24 ชั่วโมง' : 
                      overnightTime(getBuildingByRefNo, vehicleType(getParkingStatusById))
                  }
                </div>
              </div>
              <div className="detail-text mb-15">
                <div className="mr min-48" id="vehicle-fee-overnight">
                  {validateMoney(overnightAmount(getParkingStatus), true)}
                </div> บาท
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  handleShowModalProblem = (type, updateProblem) => this.setState({ 'modalProblem': true, type, updateProblem });

  handleCloseModalProblem = () => this.setState({ 'modalProblem': false, 'type': null, 'updateProblem': null });

  handleLogPayment = () => {
    const { getParkingStatusById } = this.props;

    if (!getParkingStatusById.payment || getParkingStatusById.payment.length === 0) {
      return null;
    }
    return getParkingStatusById.payment.map((element, index) => (
      <tr key={randomNumber()}>
        <td id={`payment-history-date-${index}`}>{validateToShowDash(dateDDMMYYFormat(element.updatedAt))}</td>
        <td id={`payment-history-time-${index}`}>{validateToShowDash(getTimeHHMM(element.updatedAt))}</td>
        <td id={`payment-history-amount-${index}`}>
          {validateToShowDash((element.paymentTotalParkingFeeAmount + element.paymentTotalOvernightFeeAmount) ? (element.paymentTotalParkingFeeAmount + element.paymentTotalOvernightFeeAmount).toLocaleString() : 0)} บาท
        </td>
        <td id={`payment-history-total-time-${index}`}>{validateToShowDash(minutesToHours(element.paymentTotalParkingFeeMinutes))} ชม.</td>
        <td id={`payment-history-method-${index}`}>
          <span className="menu">
            {validateToShowDash(paymentType(element))}
            <span
              id={`payment-history-receipt-${index}`}
              className="bill"
              onClick={() => this.handleModal('modalReceipts', index + 1)}
            >
              ใบเสร็จ
            </span>
          </span>
        </td>
      </tr>
    ));
  }

  handleModal = (key, activeIndexReceipts) => this.setState({ [key]: !this.state[key], activeIndexReceipts });

  handleShowTagOvernight = () => {
    try {
      const { getParkingStatusById, getParkingStatus } = this.props;

      if ((isAlreadyExist(getParkingStatusById) && !findHaveOvernight(getParkingStatusById)) || (!isAlreadyExist(getParkingStatusById) && !overnightAmount(getParkingStatus))) {
        return null;
      }

      return (
        <span className="tag-overnight" id="detail-time-total-is-overnight">
          <span className="icon far fa-clock" />
          Overnight
        </span>
      );
    } catch (error) {
      return null;
    }
  }

  render() {
    const { getParkingStatusById, getBuildingByRefNo, handleCloseModal, getParkingStatus } = this.props;
    const {
      modalVehicleOut,
      loading,
      modalProblem,
      updateProblem,
      type,
      modalReceipts,
      activeIndexReceipts,
      modalParkingGate,
    } = this.state;

    if (!getParkingStatusById || !getBuildingByRefNo) {
      return <Loading />;
    }

    return (
      <div className="ParkingDetail">
        {loading ? <Loading /> : null}
        <div className="box-parking-detail">
          <div className="box-back">
            <span className="box" id="btn-close-modal" onClick={handleCloseModal}>
              <span className="back">
                <span className="icon fas fa-arrow-left" />
              </span>
              <span className="text">กลับหน้าหลัก</span>
            </span>
          </div>
          <div className="section-car-detail-container">
            <div id="parking-ref" className="parking-ref-container">รหัสอ้างอิง : {getParkingStatusById.parking.parkingRefNo}</div>
            <div className="section-car-detail">
              <div className="car-detail">
                <div className="box-detail">
                  <div className="detail-item">
                    <div className="label">เลขทะเบียน</div>
                    <div className="value bold" id="license-plate">
                      {validateToShowDash(vehicleLicensePlate(getParkingStatusById))}
                    </div>
                    <div className="value" id="vehicle-province-detail">{vehicleProvince(getParkingStatusById)}</div>
                  </div>
                  <div className="detail-item">
                    <div className="label">สถานะรถ</div>
                    <div className="value">
                      <div>
                        <span id="parking-status" className={`status ${isAlreadyExist(getParkingStatusById) ? 'away' : 'stay'}`} />
                        {isAlreadyExist(getParkingStatusById) ? 'รถไม่อยู่ในระบบ' : 'รถอยู่ในระบบ'}
                      </div>
                      <div id="parking-check-time"><span className="icon far fa-clock" />ณ เวลา {getTimeHHMM(new Date())}</div>
                    </div>
                  </div>
                  <div className="detail-item">
                    <div className="label">อาคารจอด</div>
                    <div className="value" id="parking-detail-building">{buildingName(getBuildingByRefNo)} - {buildingRefNumber(getBuildingByRefNo)}</div>
                  </div>
                  <div className="detail-item">
                    <div className="label">Created by</div>
                    <div className="value" id="parking-create-by">{createBy(getParkingStatusById)}</div>
                  </div>
                </div>
              </div>
              <div className="car-image">
                <div className="title">ภาพถ่ายตัวรถ</div>
                <div className="box-image">
                  <img className="image" id="vehicle-image" alt="" src={carImage(getParkingStatusById)} />
                </div>
              </div>
            </div>
          </div>
          <div className="section-detail">
            <div className="box-row w-30 bg-gray box-top-bottom">
              <div>
                <div className="title-unit">
                  <span>
                    <span className="icon far fa-clock" />
                    รายละเอียดการจอดรถ
                  </span>
                </div>
                <div className="box-flex mb">
                  <div className="bg-white w-50">
                    <div className="title">เวลาเข้าจอด</div>
                    <div className="detail-text" id="parking-date-in">
                      <span className="icon far fa-calendar" />
                      {validateToShowDash(dateDDMMYYYYFormat(parkingTimeIn(getParkingStatusById)))}
                    </div>
                    <div className="detail-text" id="parking-time-in">
                      <span className="icon far fa-clock" />
                      {validateToShowDash(getTimeHHMM(parkingTimeIn(getParkingStatusById)))}
                    </div>
                  </div>
                  <div className="bg-white w-50">
                    <div className="title">เวลาออก</div>
                    <div className="detail-text" id="parking-date-out">
                      <span className="icon far fa-calendar" />
                      {validateToShowDash(dateDDMMYYYYFormat(parkingTimeOut(getParkingStatusById)))}
                    </div>
                    <div className="detail-text" id="parking-time-out">
                      <span className="icon far fa-clock" />
                      {validateToShowDash(getTimeHHMM(parkingTimeOut(getParkingStatusById)))}
                    </div>
                  </div>
                </div>
                <div className="bg-white mb">
                  <div className="title">
                    <span>เวลาจอดรถสุทธิ</span>
                    {this.handleShowTagOvernight()}
                  </div>
                  <div className="detail-time-total">
                    <span className="left" id="parking-total-time-hour">
                      {
                        validateToShowDash((
                          totalParkingTimeMinutes(getParkingStatusById) || totalParkingTimeMinutes(getParkingStatusById) === 0 ?
                            minToHr(totalParkingTimeMinutes(getParkingStatusById)).split('.')[0]
                            : parkingTimeTotal(getParkingStatus) > 0 ? timestampToHr(parkingTimeTotal(getParkingStatus)).split('.')[0] : null
                        ))
                      } ชม.
                    </span>
                    <span className="right" id="parking-total-time-minute">
                      {
                        validateToShowDash((
                          totalParkingTimeMinutes(getParkingStatusById) || totalParkingTimeMinutes(getParkingStatusById) === 0 ?
                            minToHr(totalParkingTimeMinutes(getParkingStatusById)).split('.')[1]
                            : parkingTimeTotal(getParkingStatus) > 0 ? timestampToHr(parkingTimeTotal(getParkingStatus)).split('.')[1] : null
                        ))
                      } นาที
                    </span>
                  </div>
                </div>
                <div className="title-unit">
                  <span>
                    <span className="icon icon-car" />
                    รายละเอียดตัวรถ
                  </span>
                </div>
                <div className="bg-white">
                  <div className="row-label-value">
                    <span className="label">จังหวัด</span>
                    <span className="value" id="vehicle-province">{validateToShowDash(vehicleProvince(getParkingStatusById))}</span>
                  </div>
                  <div className="row-label-value">
                    <span className="label">ประเภทรถ</span>
                    <span className="value" id="vehicle-type">{validateToShowDash(labelVehicleType(getParkingStatusById))}</span>
                  </div>
                  <div className="row-label-value">
                    <span className="label">ยี่ห้อรถ</span>
                    <span className="value" id="vehicle-brand">{validateToShowDash(vehicleBrand(getParkingStatusById))}</span>
                  </div>
                  <div className="row-label-value">
                    <span className="label">สีรถ</span>
                    <span className="value" id="vehicle-color">{validateToShowDash(vehicleColor(getParkingStatusById))}</span>
                  </div>
                  <div className="row-label-value">
                    <span className="label">รุ่นรถ</span>
                    <span className="value" id="vehicle-model">{validateToShowDash(vehicleModel(getParkingStatusById))}</span>
                  </div>
                  <div className="row-label-value">
                    <span className="label">ปี</span>
                    <span className="value" id="vehicle-year">{validateToShowDash(vehicleYear(getParkingStatusById))}</span>
                  </div>
                </div>
              </div>
              {
                !isAlreadyExist(getParkingStatusById) ?
                  <>
                    <div className="box-btn-out">
                      <Button
                        id="btn-car-out"
                        className="car-out btn-curve"
                        onClick={() => this.handleModal('modalVehicleOut')}
                      >
                        เอารถออกจากระบบ
                      </Button>
                      <Button
                        id="btn-modal-open-gate"
                        className="parking-gate btn-curve"
                        onClick={() => this.handleModal('modalParkingGate')}
                      >
                        เปิดประตู
                      </Button>
                    </div>
                    <VehicleOut modal={modalVehicleOut} handleShow={() => this.handleModal('modalVehicleOut')}/>
                    <ParkingGate modal={modalParkingGate} handleShow={() => this.handleModal('modalParkingGate')}/>
                  </>
                  : null
              }
            </div>
            <div className="box-row w-40">
              {this.handleDetailParkingStatus()}
              <div className={`bg-gray mb${isAlreadyExist(getParkingStatusById) ? ' h-100' : ''}`}>
                <div className="title-unit">
                  <span>
                    <span className="icon icon-bill-money" />
                    ประวัติการชำระค่าบริการ
                  </span>
                </div>
                <div className="bg-white payment-history">
                  <div className="box-log-payment">
                    <table className="log-payment">
                      <thead>
                        <tr>
                          <th>วันที่</th>
                          <th>เวลา</th>
                          <th>จำนวนเงิน</th>
                          <th>ชั่วโมง</th>
                          <th>ช่องทางการชำระเงิน</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.handleLogPayment()}
                      </tbody>
                    </table>
                  </div>
                </div>
                {
                  getParkingStatusById.payment && getParkingStatusById.payment.length > 0 ?
                    <>
                      <Button
                        id="btn-show-all-receipt"
                        className="view-receipt btn-curve"
                        onClick={() => this.handleModal('modalReceipts', 1)}
                      >
                        เรียกดูใบเสร็จ
                      </Button>
                      <ModalReceipts
                        modal={modalReceipts}
                        activeIndexReceipts={activeIndexReceipts}
                        handleShow={() => this.handleModal('modalReceipts')}
                        parkingID={parkingID(getParkingStatusById)}
                      />
                    </>
                    : null
                }
              </div>
            </div>
            <div className="box-row w-30 bg-gray2 box-top-bottom">
              <div className="">
                <div className="title-unit">
                  <span>
                    <span className="icon fas fa-exclamation-circle" />
                    ปัญหาที่พบ
                  </span>
                </div>
                {this.handleLogProblem()}
              </div>
              {
                !isAlreadyExist(getParkingStatusById) ?
                  <>
                    <Button
                      id="btn-add-problem"
                      className="add-problem btn-curve"
                      onClick={() => this.handleShowModalProblem(commonConstant.createProblem, getParkingStatusById)}
                    >
                      เพิ่มปัญหา
                    </Button>
                    <Problem
                      show={modalProblem}
                      type={type}
                      handleCloseModal={this.handleCloseModalProblem}
                      parkingID={parkingID(updateProblem)}
                      problem={modalProblem ? updateProblem : null}
                      handleShowModalDelete={() => this.handleShowModalProblem(commonConstant.deleteProblem, updateProblem)}
                    />
                  </>
                  : null
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ParkingDetail.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'match': PropTypes.shape({
    'path': PropTypes.string,
    'params': PropTypes.shape({
      'buildingRefNo': PropTypes.string,
      'buildingID': PropTypes.string,
    }),
  }),
  'handleCloseModal': PropTypes.func.isRequired,
  'getParkingStatusById': PropTypes.shape({
    'parkingProblem': PropTypes.array,
    'payment': PropTypes.array,
  }),
  'getBuildingByRefNo': PropTypes.shape({}),
  'getParkingStatus': PropTypes.shape({}),
  'carExit': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({}),
  }),
  'deleteProblem': PropTypes.shape({
    'status': PropTypes.any,
    'data': PropTypes.shape({}),
  }),
};

const mapStateToProps = ({ getParkingStatusById, getBuildingByRefNo, getParkingStatus, carExit, deleteProblem }) => ({
  'getParkingStatusById': getParkingStatusById.data,
  'getBuildingByRefNo': getBuildingByRefNo.data,
  'getParkingStatus': getParkingStatus.data,
  carExit,
  deleteProblem,
});

export default connect(mapStateToProps)(withRouter(ParkingDetail));
